import { render, staticRenderFns } from "./PlayNext.vue?vue&type=template&id=36b59106&scoped=true&"
import script from "./PlayNext.vue?vue&type=script&lang=js&"
export * from "./PlayNext.vue?vue&type=script&lang=js&"
import style0 from "./PlayNext.vue?vue&type=style&index=0&id=36b59106&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b59106",
  null
  
)

export default component.exports